import {
  createReqConsts,
  createActions,
  createReqWatcher,
  createReqReducer,
} from '../../../utils/redux';

const makeApplyGuarantorConfig = () => ({
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'guarantors',
    {
      type: 'payload',
      selector: ['id'],
    },
    'current_relation',
  ],
});

const requestOptions = makeApplyGuarantorConfig();

export const consts = createReqConsts('apply-guarantor');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/guarantor-information/requests/apply-guarantor-req.js